import React from 'react';
import { useDiary, pixelY } from './DiaryContext';

/**
 * NonWorkingOverlay - Grey bands for non-working hours.
 * Renders two overlays: one before staff start, one after staff end.
 */
function NonWorkingOverlay({ staff }) {
  const { state } = useDiary();
  const { viewStartMinutes, viewEndMinutes, zoomLevel } = state;

  if (!staff || staff.isWorking === false) {
    // Entire column is non-working
    return (
      <div
        className="dv2-non-working-overlay dv2-non-working-overlay--full"
        style={{
          top: 0,
          height: pixelY(viewEndMinutes, viewStartMinutes, zoomLevel),
        }}
      />
    );
  }

  const overlays = [];

  // Before working hours
  if (staff.startMinutes > viewStartMinutes) {
    overlays.push(
      <div
        key="before"
        className="dv2-non-working-overlay"
        style={{
          top: 0,
          height: pixelY(staff.startMinutes, viewStartMinutes, zoomLevel),
        }}
      />
    );
  }

  // After working hours
  if (staff.endMinutes < viewEndMinutes) {
    overlays.push(
      <div
        key="after"
        className="dv2-non-working-overlay"
        style={{
          top: pixelY(staff.endMinutes, viewStartMinutes, zoomLevel),
          height: pixelY(viewEndMinutes, viewStartMinutes, zoomLevel) - pixelY(staff.endMinutes, viewStartMinutes, zoomLevel),
        }}
      />
    );
  }

  return <>{overlays}</>;
}

export default React.memo(NonWorkingOverlay);
